<template>
  <header :class="{ 'header--smaller': !showBottom }">
    <div class="top-row">
      <div class="search-box-container">
        <search-bar
          class="search-box gyra-p-normal-sans hidden"
          v-model="searchTerm"
          :placeholder="'header.search' | translate"
          @input="onSearchTermChanged()"
        />
      </div>

      <div class="cont mobile">
        <div class="icon-container icon-container--left">
          <BIconList class="mobile icon icon--left" v-b-toggle.sidebar />
        </div>
      </div>

      <div class="gyra-banner-container">
        <img
          src="../../assets/images/gyra_banner/gyra_banner@3x.png"
          alt="Gyra Banner"
          class="gyra_banner"
          @click="onBannerClick()"
        />
        <p class="message--mobile">
          {{ `header.hashtag_message` | translate }}
        </p>
      </div>

      <div class="locate-button-container mobile">
        <div class="locate-button mobile" @click="onLocateClick">
          <p>{{ "header.map" | translate }}</p>
        </div>
      </div>

      <div class="action-group">
        <p class="message--desktop">
          {{ `header.hashtag_message` | translate }}
        </p>
      </div>
    </div>
    <div class="bottom-row" v-if="showBottom">
      <div class="nav-bar">
        <p
          class="nav sex-nav"
          :class="{
            'sex-nav--selected': isSelected($t('general.women'))
          }"
          @click="changeSex($t('general.women'))"
        >
          {{ "general.women_cool" | translate | capitalize }}
        </p>
        <p
          class="nav sex-nav"
          :class="{
            'sex-nav--selected': isSelected($t('general.men'))
          }"
          @click="changeSex($t('general.men'))"
        >
          {{ "general.men_cool" | translate | capitalize }}
        </p>
        <div
          class="cat-nav"
          @mouseenter="setDropdown(true)"
          @mouseleave="setDropdown(false)"
        >
          <p
            class="nav"
            v-for="(navItem, index) in getNavItems"
            :key="index"
            @click="
              onNavClicked(navItem);
              setDropdown(false);
            "
            @mouseover="
              getSubNavItemsForNavItem(navItem);
              hoverNavItem(navItem);
            "
            :class="{
              'nav--selected': isHoveredNav(navItem),
              'nav--highlighted': isHighlightedNav(navItem),
              'nav--hovered': isHoveredNav(navItem)
            }"
          >
            {{ `header.${navItem.name}` | translate | capitalize }}
          </p>
          <transition name="drop-down">
            <div
              class="dropdown"
              v-if="isDropdown && hoveredNavItemHasSubNavItem"
            >
              <div class="group-container">
                <div class="category-group">
                  <h3>{{ "header.categories" | translate }}</h3>
                  <div class="group-matrix">
                    <div
                      v-for="(subNavItem, i) of subNavItems"
                      class="subNavItem"
                      :class="{
                        'subNavItem--selected': isSelectedSubNav(subNavItem)
                      }"
                      :key="i"
                      @click="onSubNavClicked(subNavItem)"
                    >
                      <p>
                        {{ getTranslation(subNavItem) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="locate-button flex" @click="onLocateClick">
        <p>{{ "header.map" | translate }}</p>
      </div>
    </div>
  </header>
</template>

<script>
import SearchBar from "../atoms/search-bar";
import { categoryNavigation, errorHandling, sexNavigation } from "../../mixins";
import { getPossibleFilterValues, getSample } from "../../services/api";
import { mapMutations } from "vuex";
import { BIconList } from "bootstrap-vue";
import { productTypeNavigation } from "../../mixins/navigation/productTypeNavigation";
export default {
  name: "the-header",
  components: { SearchBar, BIconList },
  mixins: [
    sexNavigation,
    categoryNavigation,
    errorHandling,
    productTypeNavigation
  ],
  data() {
    return {
      searchTerm: null,
      isDropdown: false,
      subNavItems: [],
      hoveredNavItem: null
    };
  },
  methods: {
    onBannerClick() {
      this.$router.push({ name: "Home" });
    },
    onNavClicked(navItem) {
      this.resetProducts();
      this.setSubNavItemWithFilter(null);
      this.navigateToCategory(navItem);
    },
    onSubNavClicked(subNavItem) {
      this.resetProducts();
      this.setSubNavItemWithFilter(subNavItem);
      this.navigateToCategory(this.hoveredNavItem);
    },
    onSearchTermChanged() {
      // noop
    },
    onLocateClick() {
      this.resetFilters();
      this.getSample();
      this.$router.push({ name: "ProductMap" });
    },
    async getSample() {
      const response = await getSample();
      if (response.status === 200) {
        this.setProducts(response.data);
      } else {
        this.handleHttpError(response);
      }
    },
    setDropdown(bool) {
      if (this.isDropdown !== bool) this.isDropdown = bool;
    },
    async getSubNavItemsForNavItem(navItem) {
      // todo: since only categories have subnavs now this can be simplified
      if (!navItem.hasSubNav) return null;
      this.subNavItems = [];
      let response = null;
      const value = navItem.name;
      switch (value) {
        case "clothing":
          response = await getPossibleFilterValues("type", {
            sex: this.getSelectedSex(),
            category: value
          });
          break;
        case "shoes":
          response = await getPossibleFilterValues("type", {
            sex: this.getSelectedSex(),
            category: value
          });
          break;
        case "accessories":
          response = await getPossibleFilterValues("type", {
            sex: this.getSelectedSex(),
            category: "accessories"
          });
          break;
        case "sale":
          response = await getPossibleFilterValues("type", {
            sex: this.getSelectedSex(),
            onSale: true
          });
          break;
        // case "brands":
        //   response = await getPossibleFilterValues("brand", {
        //     sex: this.getSelectedSex()
        //   });
        //   break;
        // case "stores":
        //   response = await getPossibleFilterValues("store", {
        //     sex: this.getSelectedSex()
        //   });
        //   break;
      }
      if (response && response.status === 200) {
        this.subNavItems = response.data;
      } else {
        this.handleHttpError(response);
      }
    },
    isHoveredNav(navItem) {
      return navItem === this.hoveredNavItem;
    },
    hoverNavItem(navItem) {
      this.hoveredNavItem = navItem;
    },
    getTranslationCategory() {
      if (
        this.hoveredNavItem.name === "clothing" ||
        this.hoveredNavItem.name === "shoes" ||
        this.hoveredNavItem.name === "accessories" ||
        this.hoveredNavItem.name === "sale"
      )
        return "type";
      if (this.hoveredNavItem.name === "stores") return "store";
    },
    shouldBeTranslated() {
      return (
        this.hoveredNavItem.name === "clothing" ||
        this.hoveredNavItem.name === "shoes" ||
        this.hoveredNavItem.name === "accessories" ||
        this.hoveredNavItem.name === "sale" ||
        this.hoveredNavItem.name === "stores"
      );
    },
    getTranslation(subNavItem) {
      return this.shouldBeTranslated()
        ? this.$options.filters.capitalize(
            this.$options.filters.translate(
              `filter.${this.getTranslationCategory()}.${subNavItem}`
            )
          )
        : subNavItem;
    },
    isSelectedSubNav(subNavItem) {
      return subNavItem === this.getSubNavItem;
    },
    ...mapMutations({
      setSubNavItem: "navigation/setCurrentSubNavItem",
      resetProducts: "overview/reset",
      resetFilters: "filters/reset",
      setProducts: "overview/setProducts"
    })
  },
  computed: {
    hoveredNavItemHasSubNavItem() {
      return !this.hoveredNavItem || this.hoveredNavItem.hasSubNav;
    },
    showBottom() {
      return !(this.$route.meta.header && this.$route.meta.header.noBottom);
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
header {
  position: relative;
  height: $gyra-header-height-mobile;
  width: auto;
  @media (min-width: $gyra-breakpoint-lg) {
    height: $gyra-header-height;
  }
  padding: 34px 23px 14px 23px;
  @media (min-width: 520px) {
    padding: 34px 110px 14px 110px;
  }
  border-bottom: 2px solid $gyra-grey-lightest;
  background-color: white;
}
.header--smaller {
  height: 123px !important;
}
.top-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 0;
  border-bottom: none;
  @media (min-width: $gyra-breakpoint-lg) {
    padding-bottom: 27.5px;
    border-bottom: 2.5px solid $gyra-grey-lightest;
  }

  align-items: center;

  .gyra-banner-container {
    display: flex;
    flex: 1;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .gyra_banner {
    width: 102px;
    height: 36px;
    @media (min-width: $gyra-breakpoint-lg) {
      width: 165px;
      height: 59px;
    }
    cursor: pointer;
  }

  .search-box-container {
    /*width: auto;*/
    display: none;
    @media (min-width: $gyra-breakpoint-lg) {
      display: flex;
      flex: 1;
    }
    flex: 0;
    justify-content: center;
    align-items: center;
  }
  .search-box {
    width: 195.6px;
    height: 19px;
  }
  .action-group {
    height: 59px;
    display: none;
    flex: 0;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    @media (min-width: $gyra-breakpoint-lg) {
      display: flex;
      flex: 1;
    }
  }
  .message--desktop {
    display: none;
    @media (min-width: $gyra-breakpoint-lg) {
      display: flex;
    }
    font-weight: bold;
    margin-bottom: 0;
  }

  .message--mobile {
    display: flex;
    @media (min-width: $gyra-breakpoint-lg) {
      display: none;
    }
    font-size: 12px;
    font-weight: bold;
  }
}

.bottom-row {
  display: none;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 68.5px;
  width: 100%;

  @media (min-width: $gyra-breakpoint-lg) {
    display: flex;
  }

  .nav-bar {
    display: flex;
    flex-direction: row;

    justify-content: center;
    align-items: center;

    height: 100%;
  }
  .nav {
    font-weight: bold;
    position: relative;
    cursor: pointer;

    &:not(:last-child) {
      margin-right: 30px;
      @media (min-width: 1134px) {
        margin-right: 42px;
      }
    }

    &:hover {
    }
  }

  .sex-nav {
    opacity: 0.55;

    &:nth-child(2)::after {
      content: "";
      width: 0;
      border: 1px solid $gyra-grey-dark;
      position: absolute;
      right: -21px;
      bottom: 0;
      height: 100%;
      cursor: default;
    }
  }
  .sex-nav--selected {
    opacity: 1;
  }

  .nav--highlighted {
    color: $gyra-red;
  }

  .nav--hovered {
    transform: translateY(-2px);
    font-weight: 800;
  }

  .nav--selected {
    &::after {
      content: "";
      position: absolute;
      bottom: -10px;
      width: 100%;
      border-bottom: 2px solid $gyra-salmon;
    }
  }

  .sex-nav--selected {
    &::before {
      content: "";
      position: absolute;
      bottom: -10px;
      width: 100%;
      border-bottom: 2px solid $gyra-salmon;
    }
  }
  .cat-nav {
    display: flex;
    flex-direction: row;
    height: 100%;
    align-items: center;
  }
}

.dropdown {
  min-height: 50vh;
  width: 100vw;
  background-color: white;
  z-index: -1;
  position: absolute;
  top: 189px;
  left: 0;

  -webkit-box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  -moz-box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);

  .group-container {
    position: relative;
    display: flex;
    flex-direction: row;
    padding-top: 46px;

    h3 {
      margin-bottom: 18px;
    }

    .category-group {
      flex: 2;
      margin-left: 156px;
    }

    .group-matrix {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .subNavItem {
        margin-right: 83px;
        display: flex;
        /*flex: 0 0 15%;*/
        width: 150px;
        @media (min-width: $gyra-breakpoint-xl) {
          width: 200px;
        }
        cursor: pointer;
      }

      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:hover {
          text-decoration: underline;
        }
      }

      .subNavItem--selected {
        p {
          font-weight: 700;
          text-decoration: underline;
        }
      }
    }

    .sustainable-group {
      flex: 1;
      margin-left: 150px;
    }

    .brand-group {
      flex: 1;
      margin-left: 150px;
    }
  }
}

.drop-down-enter-active,
.drop-down-leave-active {
  transition: transform 0.4s ease-in-out;
}

.drop-down-enter,
.drop-down-leave-to {
  transform: translateY(-1200px);
}

.mobile {
  display: flex;
  @media (min-width: $gyra-breakpoint-lg) {
    display: none !important;
  }
}

.icon {
  font-size: 15px;
  box-sizing: content-box;
  cursor: pointer;
}

.icon-container {
  border-radius: 100px;
  width: 35px;
  height: 35px;
  @media (min-width: $gyra-breakpoint-lg) {
    display: none;
  }
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon-container--left {
  background-color: $gyra-grey-dark;
}

.icon-container--right {
  background-color: $gyra-mint;
}
.icon--right {
}

.icon--left {
  color: white;
}

.hidden {
  visibility: hidden;
}

.cont {
  width: 80px;
}
.flex {
  display: flex;
}
.locate-button-container {
  width: 80px;
  height: 37px;
  display: flex;
  justify-content: flex-end;
}
.locate-button {
  width: 40px;
  @media (min-width: $gyra-breakpoint-sm) {
    width: 80px;
  }
  @media (min-width: $gyra-breakpoint-lg) {
    width: 113px;
  }

  border-radius: 10px;
  background-color: $gyra-mint;
  box-shadow: 10px 10px 30px 0 rgba(0, 0, 0, 0.16);
  margin-right: 0;

  justify-content: center;
  align-items: center;
  cursor: pointer;
  p {
    @media (min-width: $gyra-breakpoint-lg) {
      font-size: 14px;
    }
    margin: 0;
    font-size: 12px;
    font-weight: bold;
  }
}
</style>
